import { SPECIES } from './animalCatalog.js';

export const PREDATOR = new Set(['fox', 'wolf', 'cheetah', 'crocodile', 'bear', 'polarbear', 'lion', 'tiger']);
export const STAR_NAMES = ['Milo', 'Luna', 'Kofi', 'Nala', 'Bao', 'Zuri', 'Kiro', 'Suki', 'Otis', 'Maya', 'Rex', 'Juno', 'Taj', 'Bella', 'Nova', 'Koda', 'Sana', 'Enzo', 'Ivy', 'Pax'];
export const CONTRACT_ZOOS = ['Savanna Park', 'Wildwood Reserve', 'Azure Bay Zoo', 'Highland Safari', 'Coral Coast Zoo', 'Nordic Wildlife Park'];
export const MANDATE_REHOME = 0.6;

export const MORPHS = {
  albino:     { label: 'Albino',     color: 0xf4efe6, value: 4, chance: 0.04 },
  melanistic: { label: 'Melanistic', color: 0x2a2726, value: 3, chance: 0.04 },
  golden:     { label: 'Golden',     color: 0xe8c24a, value: 6, chance: 0.02 },
};

export function rollMorph() {
  const r = Math.random();
  let acc = 0;
  for (const k in MORPHS) {
    acc += MORPHS[k].chance;
    if (r < acc) return k;
  }
  return null;
}

const BLOODLINE = {};
export function bloodlineFactor(sp) { const d = BLOODLINE[sp] != null ? BLOODLINE[sp] : 1; return 0.4 + 0.6 * d; }
export function bloodlinePct(sp) { return Math.round((BLOODLINE[sp] != null ? BLOODLINE[sp] : 1) * 100); }
export function bloodlineBirth(sp) { BLOODLINE[sp] = Math.max(0.25, (BLOODLINE[sp] != null ? BLOODLINE[sp] : 1) - 0.05); }
export function bloodlineFresh(sp) { BLOODLINE[sp] = Math.min(1, (BLOODLINE[sp] != null ? BLOODLINE[sp] : 1) + 0.3); }
export function bloodlineReset(sp) { BLOODLINE[sp] = 1; }

export function saleValue(animal) {
  const sp = SPECIES[animal.species];
  const age = animal.ageDays || 0;
  let f;
  if (animal.maturity < 1) f = 0.9 * bloodlineFactor(animal.species);
  else f = Math.max(0.25, 0.65 - (age - 30) * 0.004);
  if (animal.wellbeing >= 75) f *= 1.2;
  if (animal.morph && MORPHS[animal.morph]) f *= MORPHS[animal.morph].value;
  return Math.round(sp.price * f);
}

export function canShare(a, b) {
  if (a === b) return true;
  const A = SPECIES[a], B = SPECIES[b];
  if (A.group === 'exclusive' || B.group === 'exclusive') return false;
  return A.group === B.group;
}

export const BREED_GROUPS = { cattle: { m: 'bull', f: 'cow' }, cervid: { m: 'stag', f: 'deer' } };
export const BREED_OF = { bull: 'cattle', cow: 'cattle', stag: 'cervid', deer: 'cervid' };
export const FIXED_SEX = { bull: 'm', cow: 'f', stag: 'm', deer: 'f' };
export const groupOf = (species) => BREED_OF[species] || species;
